/* __next_internal_client_entry_do_not_use__ SearchPageFiltersDataContextProvider,useSearchPageFiltersDataContext auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { INITIAL_SEARCH_PAGE_FILTERS_DATA } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/ViewState/SearchPageFiltersData";
import React, { createContext, useContext } from "react";
var SearchPageFiltersDataContext = /*#__PURE__*/ createContext(INITIAL_SEARCH_PAGE_FILTERS_DATA);
export var SearchPageFiltersDataContextProvider = function(param) {
    var children = param.children, searchPageFiltersData = param.searchPageFiltersData;
    return /*#__PURE__*/ _jsx(SearchPageFiltersDataContext.Provider, {
        value: searchPageFiltersData,
        children: children
    });
};
export var useSearchPageFiltersDataContext = function() {
    var value = useContext(SearchPageFiltersDataContext);
    if (value === INITIAL_SEARCH_PAGE_FILTERS_DATA) {
        throw new Error("useSearchPageFiltersDataContext must be used within a SearchPageFiltersDataContextProvider");
    }
    return value;
};
